/* Wendle — quick add. Product links open a picker instead of the product page; in the collection wheels the
"Add to cart" button opens a size grid in place (tap a size = added). Product flies into the cart; cart shows bundle tiers. */
(() => {
'use strict';
{ const me = document.currentScript && document.currentScript.src; if (me) { const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = me.replace('bf-quick.js', 'bf-quick-2.css'); document.head.appendChild(l); } }
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const BF = window.BF = window.BF || {};
const routes = (window.Wendle && window.Wendle.routes) || {};
const root = (routes.root || '/').replace(/\/?$/, '/');
const TIERS = [{ n: 1, off: 0 }, { n: 2, off: 10 }, { n: 3, off: 15 }];
const BUNDLE_TAG = 'wendle-bundle';
const cache = {};
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const money = (c) => (BF.money ? BF.money(c) : '£' + (c / 100).toFixed(2));
const sized = (src, w) => { if (!src) return ''; const u = src.indexOf('//') === 0 ? 'https:' + src : src; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
const isColour = (n) => /^colou?r$/i.test(n);
const oname = (o) => (o && o.name) || o;
const lab = (n) => (/size/i.test(String(n)) ? 'Size' : String(n));
const unitOf = (p) => { const t = (p.type || '').toLowerCase(); if (/sock/.test(t)) return 'pack'; if (/robe|cardigan|umbrella/.test(t)) return 'item'; return 'pair'; };
const half = (n) => String(Math.round(n * 2) / 2);
const CC = (window.BF && BF.country) || 'GB';
const SYS = /^(GB|IE|GG|JE|IM)$/.test(CC) ? 'uk' : /^(US|CA)$/.test(CC) ? 'us' : 'eu';
const EUS = { '3': 33, '4': 34, '5': 35, '6': 36, '7': 37, '7.5': 38, '8': 39, '9': 40, '10': 41, '11': 42, '12': 43, '13': 44, '14': 45, '15': 46 };
const CMS = { '6': '22.4', '7': '23.0', '7.5': '23.6', '8': '24.3', '9': '25.0', '10': '25.7', '11': '26.3', '12': '26.9', '13': '27.6', '14': '28.3' };
const ukOf = (v) => {
const t = String(v); let w = null, m = null, x;
if ((x = t.match(/Women\s*([\d.\/]+)/i))) { w = x[1]; const y = t.match(/\bMen\s*([\d.\/]+)/); if (y) m = y[1]; }
else if ((x = t.match(/\bW\s*([\d.\/]+)\s*\/\s*M\s*([\d.\/]+)/))) { w = x[1]; m = x[2]; }
else if ((x = t.match(/US\s*W\s*([\d.]+(?:\s*[–-]\s*[\d.]+)?)/i))) { w = x[1].replace(/\s*[–-]\s*/, '/'); const y = t.match(/\bM\s*([\d.]+(?:\s*[–-]\s*[\d.]+)?)/); if (y) m = y[1].replace(/\s*[–-]\s*/, '/'); }
if (!w) return { main: t.split(/\s+·\s+/)[0], sub: '' };
const parts = w.split('/').filter(Boolean), cm = CMS[parts[0]];
if (SYS === 'us') return { main: 'US W' + w + (m ? ' / M' + m : ''), sub: '' };
if (SYS === 'uk') return { main: 'UK ' + parts.map((q) => half(+q - 2)).join('/'), sub: cm ? cm + ' cm' : '' };
const eu = EUS[parts[0]]; return eu ? { main: 'EU ' + eu, sub: cm ? cm + ' cm' : '' } : { main: 'US W' + w, sub: '' };
};
const sizeLab = (v) => { const u = ukOf(v); return `<b>${esc(u.main)}</b>${u.sub ? `<small>${esc(u.sub)}</small>` : ''}`; };
const shortSize = (v) => ukOf(v).main;
const deal = (u) => `<p class="bfq-deal"><span>Bundle &amp; save</span>2 ${u}s <b>−10%</b><i></i>3 ${u}s <b>−15%</b></p>`;
const plural = (u, n) => (n === 1 ? u : u + 's');
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const isBundle = (p) => (p.tags || []).some((t) => t === BUNDLE_TAG || t === 'barelow');
const getProduct = (h) => cache[h] || (cache[h] = fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then((r) => { if (!r.ok) throw new Error('Product not found'); return r.json(); }).catch((e) => { delete cache[h]; throw e; }));
const variantFor = (p, sel) => p.variants.find((v) => v.options.every((o, i) => o === sel[i]));
const possible = (p, sel, i, val) => p.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || !sel[j] || o === sel[j]));
const colourIdx = (p) => p.options.findIndex((o) => isColour(oname(o)));
const sizeIdxs = (p) => p.options.map((o, i) => i).filter((i) => !isColour(oname(p.options[i])) && (p.options[i].values || []).length > 1);

/* ---------- modal picker (cards, menu, search, upsells) ---------- */
let box, st = null, lastFocus = null;
const build = () => {
if (box) return box;
box = document.createElement('div');
box.className = 'bfq'; box.id = 'BfQuick'; box.hidden = true;
box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'BfQuickT');
box.innerHTML = `<div class="bfq__bg" data-bfq-close></div>
<div class="bfq__box">
<button type="button" class="bfq__x" data-bfq-close aria-label="Close">✕</button>
<div class="bfq__top">
<div class="bfq__img"><img alt="" data-bfq-img></div>
<div class="bfq__head"><p class="bfq__t" id="BfQuickT" data-bfq-title></p><p class="bfq__p" data-bfq-price></p></div>
</div>
<div class="bfq__opts" data-bfq-opts></div>
<div class="bfq__tiers" data-bfq-tiers></div>
<p class="bfq__msg" data-bfq-msg role="alert"></p>
<button type="button" class="bf-btn bfq__add" data-bfq-add>Add to cart</button>
</div>`;
document.body.appendChild(box);
box.addEventListener('click', (e) => {
if (e.target.closest('[data-bfq-close]')) { close(); return; }
const o = e.target.closest('[data-bfq-opt]');
if (o) { const i = +o.dataset.bfqOpt; st.sel[i] = o.dataset.val; st.sel.forEach((x, j) => { if (j !== i && x && (st.p.options[j].values || []).length > 1 && !possible(st.p, st.sel, j, x)) st.sel[j] = null; }); $('[data-bfq-msg]', box).textContent = ''; renderOpts(); renderRest(); return; }
const t = e.target.closest('[data-bfq-tier]');
if (t) { st.qty = +t.dataset.bfqTier; renderRest(); return; }
if (e.target.closest('[data-bfq-add]')) submit();
});
box.addEventListener('keydown', (e) => {
if (e.key === 'Escape') { e.stopPropagation(); close(); }
if (e.key === 'Tab') { const f = $$('button:not([disabled]),[tabindex="0"]', box).filter((x) => x.offsetParent); if (!f.length) return; const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
});
return box;
};
const imgFor = (p, sel) => {
const ci = colourIdx(p);
let v = variantFor(p, sel);
if (!v && ci > -1 && sel[ci]) v = p.variants.find((x) => x.options[ci] === sel[ci]);
if (v && v.featured_image) return v.featured_image.src;
if (ci > -1 && sel[ci] && p.media) { const want = String(sel[ci]).toLowerCase(); const m = p.media.find((x) => (x.alt || '').toLowerCase() === want); if (m) return m.src || (m.preview_image && m.preview_image.src); }
return p.featured_image;
};
const colourThumb = (p, ci, val) => { const v = p.variants.find((x) => x.options[ci] === val && x.featured_image); if (v) return v.featured_image.src; const want = String(val).toLowerCase(); const m = (p.media || []).find((x) => (x.alt || '').toLowerCase() === want); return m ? (m.src || (m.preview_image && m.preview_image.src)) : ''; };

const renderOpts = () => {
const p = st.p, sel = st.sel, wrap = $('[data-bfq-opts]', box);
wrap.innerHTML = '';
p.options.forEach((o, i) => {
const name = oname(o), vals = o.values || [];
if (vals.length < 2) return;
const g = document.createElement('div'); g.className = 'bfq__opt';
if (isColour(name)) {
g.innerHTML = `<p class="bfq__lab">${esc(name)}: <b data-lab="${i}">${esc(sel[i] || '')}</b></p><div class="bfq__cs">${vals.map((val) => { const th = colourThumb(p, i, val), on = sel[i] === val; return `<button type="button" class="bfq__c${on ? ' is-on' : ''}" data-bfq-opt="${i}" data-val="${esc(val)}" aria-pressed="${on}" title="${esc(val)}" aria-label="${esc(val)}">${th ? `<img src="${esc(sized(th, 120))}" alt="" loading="lazy">` : `<span>${esc(val)}</span>`}</button>`; }).join('')}</div>`;
} else {
g.innerHTML = `<p class="bfq__lab">${esc(lab(name))}: <b>${sel[i] ? esc(shortSize(sel[i])) : 'select'}</b></p><div class="bfq-grid">${vals.map((val) => { const on = sel[i] === val, ok = possible(p, sel, i, val); return `<button type="button" class="bfq-sz${on ? ' is-on' : ''}" data-bfq-opt="${i}" data-val="${esc(val)}" aria-pressed="${on}"${ok ? '' : ' disabled'}>${sizeLab(val)}</button>`; }).join('')}</div>`;
}
wrap.appendChild(g);
});
};
const renderRest = () => {
const p = st.p, sel = st.sel;
const im = $('[data-bfq-img]', box), src = imgFor(p, sel);
if (src) { im.src = sized(src, 600); im.hidden = false; } else im.hidden = true;
const v = variantFor(p, sel);
const price = v ? v.price : p.price, cp = v ? v.compare_at_price : p.compare_at_price;
$('[data-bfq-price]', box).innerHTML = `<b>${money(price)}</b>${cp > price ? `<s>${money(cp)}</s>` : ''}`;
const ci = colourIdx(p);
if (ci > -1) $$('.bfq__c', box).forEach((b) => b.classList.toggle('is-out', !possible(p, sel, ci, b.dataset.val)));
const tw = $('[data-bfq-tiers]', box);
if (st.bundle) {
const u = st.unit;
tw.innerHTML = `<p class="bfq__lab">Bundle &amp; save</p><div class="bft">${TIERS.map((t) => {
const per = Math.round(price * (100 - t.off) / 100);
return `<button type="button" class="bft__b${st.qty === t.n ? ' is-on' : ''}" data-bfq-tier="${t.n}" aria-pressed="${st.qty === t.n}"><span>${t.n} ${plural(u, t.n)}${t.off ? ` <em>−${t.off}%</em>` : ''}</span><b>${money(per)}<small>/${u}</small></b></button>`;
}).join('')}</div>`;
} else tw.innerHTML = '';
const add = $('[data-bfq-add]', box);
const missing = p.options.findIndex((o, i) => !sel[i]);
if (missing > -1) { add.textContent = 'Choose your ' + lab(oname(p.options[missing])).toLowerCase(); add.disabled = false; add.dataset.state = 'choose'; }
else if (!v || !v.available) { add.textContent = 'Sold out'; add.disabled = true; add.dataset.state = 'out'; }
else { const per = Math.round(price * (100 - (TIERS[st.qty - 1] || TIERS[0]).off) / 100); add.textContent = `Add to cart · ${money(per * st.qty)}`; add.disabled = false; add.dataset.state = 'ok'; }
};
const startSel = (p, variantId) => {
const pre = variantId && p.variants.find((v) => String(v.id) === String(variantId));
return p.options.map((o, i) => {
const vals = o.values || [];
if (vals.length === 1) return vals[0];
if (isColour(oname(o))) return pre ? pre.options[i] : (p.variants.find((v) => v.available) || p.variants[0]).options[i];
return null; /* size: always a conscious choice */
});
};
const open = (p, variantId, trigger) => {
build(); lastFocus = trigger || document.activeElement;
st = { p, sel: startSel(p, variantId), qty: 1, bundle: isBundle(p), unit: unitOf(p) };
$('[data-bfq-title]', box).textContent = p.title;
$('[data-bfq-msg]', box).textContent = '';
box.hidden = false; requestAnimationFrame(() => box.classList.add('is-open'));
document.documentElement.classList.add('bfq-lock');
renderOpts(); renderRest();
const first = $('.bfq-sz:not([disabled]), [data-bfq-add]', box); if (first) first.focus({ preventScroll: true });
};
const close = () => {
if (!box || box.hidden) return;
box.classList.remove('is-open'); document.documentElement.classList.remove('bfq-lock');
setTimeout(() => { box.hidden = true; }, 220);
if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
};

/* ---------- fly to cart ---------- */
const cartTarget = () => {
const d = $('#BfCart.is-open .bf-cart__head a'); if (d) return d;
return $$('[data-bf-cart-open]').find((e) => e.offsetParent !== null && e.getBoundingClientRect().width > 0) || null;
};
const bump = (el) => { if (!el) return; el.classList.remove('bfq-bump'); void el.offsetWidth; el.classList.add('bfq-bump'); setTimeout(() => el.classList.remove('bfq-bump'), 700); };
const fly = (fromImg) => {
const to = cartTarget();
if (!fromImg || !to || reduced() || !fromImg.animate) { bump(to); return Promise.resolve(); }
const a = fromImg.getBoundingClientRect(), b = to.getBoundingClientRect();
if (!a.width) { bump(to); return Promise.resolve(); }
const c = document.createElement('img'); c.src = fromImg.currentSrc || fromImg.src; c.alt = ''; c.className = 'bfq-fly';
Object.assign(c.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
document.body.appendChild(c);
const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
const k = Math.max(0.06, 34 / Math.max(a.width, a.height));
const an = c.animate([
{ transform: 'translate(0,0) scale(1)', opacity: 1 },
{ transform: `translate(${dx * 0.45}px,${dy * 0.45 - 70}px) scale(${Math.max(k, 0.45)})`, opacity: 1, offset: 0.5 },
{ transform: `translate(${dx}px,${dy}px) scale(${k})`, opacity: 0.6 }
], { duration: 760, easing: 'cubic-bezier(.55,0,.35,1)' });
return an.finished.catch(() => {}).then(() => { c.remove(); bump(to); });
};

/* ---------- "added" notice ---------- */
let nt;
const notice = (p, v, qty) => {
if ($('#BfCart.is-open')) { BF.toast && BF.toast('Added to your cart'); return; }
let n = $('#BfAdded');
if (!n) { n = document.createElement('div'); n.id = 'BfAdded'; n.className = 'bfq-done'; n.setAttribute('role', 'status'); document.body.appendChild(n); n.addEventListener('mouseenter', () => clearTimeout(nt)); n.addEventListener('mouseleave', () => { nt = setTimeout(hideN, 2500); }); }
const u = unitOf(p);
const src = (v.featured_image && v.featured_image.src) || p.featured_image;
const next = TIERS.find((t) => t.n === qty + 1);
n.innerHTML = `<div class="bfq-done__row">${src ? `<img src="${esc(sized(src, 160))}" alt="">` : ''}<div><p class="bfq-done__ok">✓ Added to your cart</p><p class="bfq-done__t">${esc(p.title)}${v.public_title ? ` <span>${esc(v.options.map((x) => (/Women|US\s*W|\bW\s*\d|EU\s*\d/.test(x) ? ukOf(x).main : x)).join(' / '))}</span>` : ''}${qty > 1 ? ` <span>× ${qty}</span>` : ''}</p></div><button type="button" class="bfq-done__x" data-bfq-done-x aria-label="Close">✕</button></div>
${isBundle(p) && next ? `<button type="button" class="bfq-done__more" data-bfq-more="${v.id}">+ Add a ${qty === 1 ? '2nd' : '3rd'} ${u} &amp; save ${next.off}%</button>` : ''}
<div class="bfq-done__btns"><button type="button" class="bf-btn bf-btn--ghost" data-bfq-view>View cart</button><a class="bf-btn" href="${root}checkout">Checkout</a></div>`;
n.hidden = false; requestAnimationFrame(() => n.classList.add('is-on'));
clearTimeout(nt); nt = setTimeout(hideN, 4500);
};
const hideN = () => { const n = $('#BfAdded'); if (!n) return; n.classList.remove('is-on'); setTimeout(() => { n.hidden = true; }, 250); };
document.addEventListener('click', async (e) => {
if (e.target.closest('[data-bfq-done-x]')) { hideN(); return; }
if (e.target.closest('[data-bfq-view]')) { hideN(); BF.openCart && BF.openCart(); return; }
const m = e.target.closest('[data-bfq-more]');
if (m) { m.disabled = true; try { await BF.add([{ id: +m.dataset.bfqMore, quantity: 1 }], false); hideN(); BF.openCart && BF.openCart(); } catch (err) { BF.toast && BF.toast(err.message); m.disabled = false; } }
});

/* ---------- add (modal) ---------- */
const submit = async () => {
const p = st.p, v = variantFor(p, st.sel), add = $('[data-bfq-add]', box), msg = $('[data-bfq-msg]', box);
if (add.dataset.state === 'choose') { const i = p.options.findIndex((o, j) => !st.sel[j]); msg.textContent = 'Please choose your ' + lab(oname(p.options[i])).toLowerCase() + '.'; const g = $$('.bfq__opt', box).find((x) => x.querySelector('.bfq-grid')); if (g) { g.classList.remove('is-shake'); void g.offsetWidth; g.classList.add('is-shake'); } return; }
if (!v || !v.available) return;
add.classList.add('is-loading'); add.disabled = true;
const im = $('[data-bfq-img]', box), qty = st.qty;
try {
await BF.add([{ id: v.id, quantity: qty }], false);
const flying = fly(im); close(); await flying; notice(p, v, qty);
} catch (err) { msg.textContent = err.message || 'Something went wrong. Please try again.'; }
add.classList.remove('is-loading'); add.disabled = false;
};
const nearestImg = (el) => {
const c = el.closest('.bfw-card, .bfw, .bf-card, .bf-sk, .bf-mprod, li, article') || el.parentElement;
const imgs = $$('img', c).filter((i) => i.offsetParent && i.getBoundingClientRect().width > 20);
if (!imgs.length) return null;
const r = c.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
return imgs.sort((a, b) => { const A = a.getBoundingClientRect(), B = b.getBoundingClientRect(); return Math.hypot(A.left + A.width / 2 - cx, A.top + A.height / 2 - cy) - Math.hypot(B.left + B.width / 2 - cx, B.top + B.height / 2 - cy); })[0];
};

/* ---------- inline size grid inside a collection wheel: tap a size = added ---------- */
const parse = (href) => { try { const u = new URL(href, location.href); const m = u.pathname.match(/\/products\/([^/?#]+)/); return m ? { h: decodeURIComponent(m[1]), v: u.searchParams.get('variant') } : null; } catch (e) { return null; } };
const inline = async (btn, refresh) => {
const info = btn.parentElement, wheel = btn.closest('[data-bfw]'), q = parse(btn.href); if (!q) return;
btn.classList.add('is-loading');
let p; try { p = await getProduct(q.h); } catch (err) { BF.toast && BF.toast(err.message); btn.classList.remove('is-loading'); return; }
btn.classList.remove('is-loading');
const si = sizeIdxs(p);
if (p.variants.length === 1) { const v = p.variants[0]; if (!v.available) { BF.toast && BF.toast('Sold out'); return; } await BF.add([{ id: v.id, quantity: 1 }], false); await fly($('[data-bfw-item].is-active img', wheel)); notice(p, v, 1); return; }
if (si.length !== 1) { open(p, q.v, btn); return; }
const i = si[0], vals = p.options[i].values, sel = startSel(p, q.v);
let pan = $('.bfq-in', info);
if (!pan) { if (refresh) return; pan = document.createElement('div'); pan.className = 'bfq-in'; btn.after(pan); }
btn.hidden = true;
pan.innerHTML = `<div class="bfq-in__head"><span>Select your ${esc(lab(oname(p.options[i])).toLowerCase())}</span><button type="button" class="bfq-in__x" data-in-x aria-label="Close sizes">✕</button></div><div class="bfq-grid">${vals.map((val, k) => `<button type="button" class="bfq-sz" data-k="${k}"${possible(p, sel, i, val) ? '' : ' disabled'}>${sizeLab(val)}</button>`).join('')}</div>${isBundle(p) ? deal(unitOf(p)) : ''}`;
$('[data-in-x]', pan).onclick = () => { pan.remove(); btn.hidden = false; btn.focus({ preventScroll: true }); };
$$('.bfq-sz', pan).forEach((c) => { c.onclick = async () => {
sel[i] = vals[+c.dataset.k]; const v = variantFor(p, sel); if (!v || !v.available) return;
c.classList.add('is-loading'); $$('.bfq-sz', pan).forEach((x) => { x.disabled = true; });
try { await BF.add([{ id: v.id, quantity: 1 }], false); c.classList.add('is-on'); await fly($('[data-bfw-item].is-active img', wheel)); notice(p, v, 1); pan.remove(); btn.hidden = false; }
catch (err) { BF.toast && BF.toast(err.message); $$('.bfq-sz', pan).forEach((x) => { x.disabled = false; }); c.classList.remove('is-loading'); }
}; });
if (!refresh) { const f = $('.bfq-sz:not([disabled])', pan); if (f) f.focus({ preventScroll: true }); }
};
/* colour changed in the wheel while the sizes are open: follow it */
document.addEventListener('bfw:change', (e) => {
const w = e.target; const pan = w.querySelector && $('.bfq-in', w); if (!pan) return;
const btn = $('[data-bfw-btn]', w); if (btn) inline(btn, true);
}, true);

BF.quick = async (handle, variantId, trigger) => {
if (trigger) trigger.classList.add('is-loading');
try {
const p = await getProduct(handle);
if (p.variants.length === 1) {
const v = p.variants[0]; if (!v.available) { BF.toast && BF.toast('Sold out'); return; }
await BF.add([{ id: v.id, quantity: 1 }], false);
await fly(trigger ? nearestImg(trigger) : null); notice(p, v, 1);
} else open(p, variantId, trigger);
} catch (err) { BF.toast && BF.toast(err.message || 'Something went wrong'); }
finally { if (trigger) trigger.classList.remove('is-loading'); }
};

/* Wheels: clicking the centred shoe opens the sizes too (drags are ignored). */
let pd = null;
document.addEventListener('pointerdown', (e) => { pd = { x: e.clientX, y: e.clientY }; }, true);
document.addEventListener('click', (e) => {
const it = e.target.closest('[data-bfw-item].is-active'); if (!it) return;
if (pd && Math.hypot(e.clientX - pd.x, e.clientY - pd.y) > 8) return;
const w = it.closest('[data-bfw]'), b = w && $('[data-bfw-btn]', w); if (!b) return;
e.preventDefault(); e.stopPropagation(); inline(b);
}, true);

/* Every product link on the site opens the picker instead of the product page. */
document.addEventListener('click', (e) => {
if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
const a = e.target.closest('a[href*="/products/"]');
if (!a || a.closest('[data-bf-no-quick], #BfQuick') || document.body.classList.contains('template-product')) return;
const q = parse(a.href); if (!q) return;
try { if (new URL(a.href, location.href).origin !== location.origin) return; } catch (er) { return; }
e.preventDefault(); e.stopPropagation();
if (a.matches('[data-bfw-btn]')) inline(a); else BF.quick(q.h, q.v, a);
}, true);

/* ---------- cart bundle tiers ---------- */
document.addEventListener('click', async (e) => {
const t = e.target.closest('[data-bf-tier]'); if (!t) return;
const w = t.closest('[data-bf-tiers]'); if (!w || t.getAttribute('aria-pressed') === 'true') return;
const n = +t.dataset.bfTier, total = +w.dataset.total, lq = +w.dataset.lineQty;
const q = Math.max(1, lq + n - total);
w.classList.add('is-busy');
try { await BF.change(w.dataset.key, q); } catch (err) { BF.toast && BF.toast(err.message); w.classList.remove('is-busy'); }
});
})();

/* BareLow: the Shop button on cards opens the quick-add picker; image and title go to the product page. */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-bf-quick]');
  if (!b || e.button || e.metaKey || e.ctrlKey || e.shiftKey || !window.BF || !BF.quick) return;
  e.preventDefault(); e.stopPropagation();
  BF.quick(b.dataset.bfQuick, b.dataset.variant || null, b);
}, true);
